var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinSymbolSvg0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_2779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9632 15.6004H12.3612V11.5656C12.3612 10.6034 12.3438 9.36486 11.0078 9.36486C9.65259 9.36486 9.44523 10.4132 9.44523 11.4955V15.6001H6.84316V7.3029H9.34114V8.43681H9.37611C9.62611 8.01358 9.98735 7.66542 10.4214 7.4294C10.8554 7.19338 11.3459 7.07833 11.8408 7.09652C14.4781 7.09652 14.9643 8.81415 14.9643 11.0487L14.9632 15.6004ZM3.90716 6.16873C3.60851 6.16879 3.31654 6.08115 3.06819 5.91691C2.81984 5.75266 2.62627 5.51919 2.51193 5.24601C2.39759 4.97283 2.36763 4.67221 2.42584 4.38217C2.48405 4.09213 2.62782 3.8257 2.83896 3.61656C3.05011 3.40742 3.31914 3.26498 3.61204 3.20723C3.90495 3.14949 4.20856 3.17905 4.4845 3.29216C4.76044 3.40528 4.9963 3.59687 5.16227 3.84271C5.32824 4.08856 5.41685 4.37761 5.41691 4.67333C5.41694 4.86967 5.37791 5.0641 5.30206 5.24551C5.22621 5.42692 5.11502 5.59177 4.97483 5.73063C4.83464 5.86949 4.66818 5.97965 4.48499 6.05482C4.3018 6.12999 4.10546 6.1687 3.90716 6.16873ZM5.20819 15.6004H2.60342V7.3029H5.20819V15.6004ZM16.2605 0.785853H1.29589C0.956232 0.782057 0.628935 0.911936 0.385943 1.14695C0.142952 1.38196 0.00414529 1.70288 0 2.03918V16.9179C0.00400342 17.2543 0.142729 17.5755 0.385712 17.8107C0.628695 18.046 0.956063 18.1761 1.29589 18.1725H16.2605C16.601 18.1768 16.9293 18.047 17.1732 17.8117C17.4171 17.5765 17.5568 17.255 17.5615 16.9179V2.03811C17.5567 1.70114 17.4169 1.37985 17.173 1.14485C16.929 0.909842 16.6008 0.780334 16.2605 0.784779",
    fill: "#AD2624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_2779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.9998,
    fill: "white",
    transform: "translate(0 0.784668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSymbolSvg0);
export default __webpack_public_path__ + "static/media/linkedin-symbol-svg0.ee772667160ea405e22300d02209e3cc.svg";
export { ForwardRef as ReactComponent };